import {
  put, all, call, select, takeLatest,
} from 'redux-saga/effects';
import { exception } from 'circe/logger';
import { delay } from 'redux-saga';
import { show as showNotification } from 'circe/notifications/actions';
import * as I18n from 'circe/I18n';
import { fetch, assign } from './actions';
import { fetched } from '../actions';
import { fetch as fetchApi, assign as assignApi } from './api';

function* doFetch() {
  try {
    let allShipments = [];
    let resp = yield call(fetchApi, null);

    if (!resp) {
      throw new Error('My Shipments failed to load');
    }

    yield put(fetched(resp.results));

    allShipments = allShipments.concat(resp.results);

    while (resp.nextPage && resp.nextPage.hasResults) {
      yield delay(750);

      resp = yield call(fetchApi, resp.nextPage.cursor);

      allShipments = allShipments.concat(resp.results);

      yield put(fetched(allShipments));
    }
  } catch (e) {
    exception(e);
  }
}

function* doAssignShipments(action) {
  try {
    const {
      payload: { shipments },
    } = action;

    if (shipments.length === 0) {
      return;
    }

    const resp = yield call(assignApi, shipments);

    if (!resp) {
      throw new Error('Unable to assign shipments');
    }

    if (resp.length === 0) {
      yield put(showNotification(I18n.str('assignFailed', 'Unable to assign shipments.'), 'error'));
      return;
    }
  } catch (error) {
    yield put(showNotification(I18n.str('assignFailed', 'Unable to assign shipments.'), 'error'));
    exception(error);
  }
}

export default function* () {
  yield all([takeLatest(fetch().type, doFetch), takeLatest(assign().type, doAssignShipments)]);
}
